import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import invariant from "invariant";
import Transport from "@ledgerhq/hw-transport";
export var getAppAndVersion = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transport) {
    var r, i, format, nameLength, name, versionLength, version, flagLength, flags;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return transport.send(0xb0, 0x01, 0x00, 0x00);

          case 2:
            r = _context.sent;
            i = 0;
            format = r[i++];
            invariant(format === 1, "getAppAndVersion: format not supported");
            nameLength = r[i++];
            name = r.slice(i, i += nameLength).toString("ascii");
            versionLength = r[i++];
            version = r.slice(i, i += versionLength).toString("ascii");
            flagLength = r[i++];
            flags = r.slice(i, i += flagLength);
            return _context.abrupt("return", {
              name: name,
              version: version,
              flags: flags
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAppAndVersion(_x) {
    return _ref.apply(this, arguments);
  };
}();